<template>
  <div class="TextPopup">
    <van-popup v-model:show="PopupShow" round style="height: 36vh" position="bottom">
      <div class="m_textword">
        <div class="title">{{ title }}</div>
        <div class="contant" v-html="contant"></div>
        <div class="btns">
          <button type="button" class="cancer" @click="CancerClick">关闭</button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script setup>
import { ref, defineProps, toRefs, defineExpose } from "vue";

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  contant: {
    type: String,
    required: true,
  },
});

const PopupShow = ref(false);

const OpenClick = () => {
  PopupShow.value = true;
};

const CancerClick = () => {
  PopupShow.value = false;
};



const { title, contant } = toRefs(props);

defineExpose({ OpenClick });
</script>

<style lang="less" scoped>
.m_textword {
  padding: 30px 20px;
  display: flex;
  flex-flow: column;
  height: 100%;
  box-sizing: border-box;
  .title {
    color: @font-color;
    font-size: @title-size;
    line-height: @title-size;
    font-weight: bold;
    text-align: center;
    padding: 20px 0 30px 0;
  }
  .contant {
    color: @font-third-color;
    font-size: @subtitle-size;
    text-align: justify;
    flex-grow: 1;
    height: 10px;
    overflow-y: auto;
    margin-bottom: 30px;
  }

  .btns {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .cancer {
      width: 30%;
      height: 80px;
      outline: none;
      background: @theme-secondary-color;
      color: #fff;
      font-size: @font-size;
      font-family: "Bold";
      border-radius: 49px;
      margin-right: 20px;
    }
  }
}
</style>
